import { DestroyRef, Injectable } from '@angular/core';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { environment } from '@gestor-web/environments/environment';
import { Subject, takeUntil, tap } from 'rxjs';

const CLARITY_KEY = 'ruu21n0niu';

@Injectable({ providedIn: 'root' })
export class ClarityScriptService {
  private initialized: boolean = false;
  private ngDestroyed$ = new Subject<void>();

  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {
    const unregister = this.destroyRef.onDestroy(() => {
      this.ngDestroyed$.next();
      this.ngDestroyed$.complete();
      unregister();
    });

    this.store
      .select(UserProfileSelectors.selectCookieAcceptAll)
      .pipe(
        takeUntil(this.ngDestroyed$),
        // tap(all => console.log('[Script::Clarity] listening cookie consent:', all)),
      )
      .subscribe(all => {
        if (all) {
          this.initClarity();
        }
      });

    this.store
      .select(UserProfileSelectors.selectUserEmail)
      .pipe(
        takeUntil(this.ngDestroyed$),
        tap(email => {
          // console.log('[Clarity] email: ', email);
          if (!!email && this.initialized && typeof window['clarity'] === 'function') {
            const isBlendus = email.endsWith('@blendus.com.br');
            window['clarity']('set', 'is_blendus', isBlendus ? 'true' : 'false');
          }
        }),
      )
      .subscribe();
  }

  private initClarity() {
    // console.log('[Script::Clarity] initClarity...');
    if (!environment.production) {
      return;
    }
    if (this.initialized) {
      // console.log('[Script::Clarity] initClarity... skipped!');
      return;
    }

    // console.log('[Script::Clarity] initClarity... initializing!');

    // Clarity global function
    window['clarity'] = function () {
      // console.log('clarity[angular] - arguments:', arguments);
      window['clarity'].q = window['clarity'].q || [];
      window['clarity'].q.push(arguments);
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.clarity.ms/tag/' + CLARITY_KEY;
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    this.initialized = true;
  }
}
